import { COUPON_DISCOUNT_TYPE, AWARY_TYPE, fullDiscountType, currencyList } from '../enum/env'
import { getLabelText } from '../utils'
import { getDiscountFromCountry } from './fn'
import GenerateEnum from '../generateEnum'
const couponInvoicingType = new GenerateEnum({
  CUSTOM: {
    value: 0,
    label: getLabelText({
      key: 'remote.common.customizedDiscountCoupons',
      text: '自定义满减券'
    })
  },
  PRIMARY: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.mainCouponFullInvoiceUsage',
      text: '主券_全额开票使用'
    })
  },
  SECOND: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.couponSortingUse',
      text: '副券_清分使用'
    })
  }
})
//处理折扣字段
function getDiscountTenths(discountTenths) {
  //解决数据由监听触发多次，如果是string重新走以下计算的问题
  if (typeof discountTenths === 'string' && discountTenths.indexOf('%') !== -1) {
    return discountTenths
  }
  let num = discountTenths % 1 === 0 ? Math.floor(discountTenths) : discountTenths
  return getDiscountFromCountry() ? num : `${Math.floor((10 - num) * 10)}%`
}
//判断是否为折扣券
function getDiscountTenthsType(discountType) {
  return discountType === COUPON_DISCOUNT_TYPE.PERCENT
}
//判断取金额还是折扣字段
function getCouponMoneyOrTenths({ discountType, discountTenths, awardMoney, voucherMoney }) {
  return getDiscountTenthsType(discountType) ? getDiscountTenths(discountTenths) : awardMoney || voucherMoney
}
function getDiscountTypeText(discountType) {
  return getDiscountTenthsType(discountType) ? getLabelText({ key: 'remote.common.discount2', text: '折扣' }) : ''
}
//是否是满减
function isCouponFullReduction(fullReductionType) {
  return fullReductionType == '0' || fullReductionType == '1'
}
//优惠券名称拼接
function getCouponTypeText({ fullReductionType, discountType }) {
  if (getDiscountTenthsType(discountType)) {
    return getLabelText({
      key: isCouponFullReduction(fullReductionType) ? 'remote.coupon.fullDiscountCoupon' : 'remote.coupon.instantDiscountCoupon',
      text: isCouponFullReduction(fullReductionType) ? '满减折扣券' : '立减折扣券',
    })
  } else {
    return getLabelText({
      key: isCouponFullReduction(fullReductionType) ? 'remote.common.fullDiscountCoupon' : 'remote.common.immediatelyReduceTheCoupon',
      text: isCouponFullReduction(fullReductionType) ? '满减券' : '立减券',
    })
  }
}
function getCouponAllTypeText({ fullReductionType, discountType, awardWay }) {
  return [AWARY_TYPE.COUPONBAG, AWARY_TYPE.SERVICECOUPON].includes(String(awardWay)) ? AWARY_TYPE.getValueToLabel(awardWay) : getCouponTypeText({ fullReductionType, discountType })
}
//优惠券后缀文案，是折扣要把折放后边
function getCouponSuffixText(discountType) {
  return getDiscountTenthsType(discountType) ? getLabelText({ key: 'remote.common.fold', text: '折' }) : getDiscountFromCountry() ? '' : getLabelText({ key: 'remote.common.fold', text: '折' })
}
//不是折扣有要把币种单位放价格前边
function getCouponPriceIcon(discountType, type) {
  const getters = typeof window !== 'undefined' ? window?.app?.$store?.getters : false
  return !getDiscountTenthsType(discountType) || type ? currencyList.find((x) => x.value === (getters?.ISGJT ? 'EUR' : 'CNY'))?.symbol : ''
}
function getCouponBeforeText(discountType) {
  return getDiscountTenthsType(discountType) ? getLabelText({ key: 'remote.coupon.hit', text: '打' }) : getLabelText({ key: 'remote.common.minus', text: '减' })
}
//例如： 打1.5折， 减600元
function getCouponMoneyShowText(item) {
  const { discountType } = item
  return `${getCouponBeforeText(discountType)}${getCouponPriceIcon(discountType)}${getCouponMoneyOrTenths(item)}${getCouponSuffixText(discountType)}`
}
function showCommon(record) {
  return (
    ([9, 23].includes(+record.taxCountry || +record.country) && [0, 1, 2].includes(+record.serviceType)) ||
    ([32].includes(+record.taxCountry || +record.country) && [1, 2].includes(+record.serviceType)) ||
    ([10].includes(+record.taxCountry || +record.country) && [2].includes(+record.serviceType)) ||
    ([26].includes(+record.taxCountry || +record.country) && [0, 2, 49, 74, 75].includes(+record.serviceType)) ||
    ([1, 2, 7].includes(+record.taxCountry || +record.country) && [49, 50, 74, 75].includes(+record.serviceType)) ||
    ([3, 4].includes(+record.taxCountry || +record.country) && [49, 74, 75].includes(+record.serviceType)) ||
    ([106].includes(+record.taxCountry || +record.country) && [43, 44, 46].includes(+record.serviceType)) ||
    ([245].includes(+record.taxCountry || +record.country) && [70, 71, 72].includes(+record.serviceType))
  )
}
function getDeductionLimit({ maxSubMoney, deductionScope }) {
  const getters = typeof window !== 'undefined' ? window?.app?.$store?.getters : false
  return maxSubMoney || deductionScope
    ? `，${getLabelText({ key: 'remote.common.upperLimit', text: '上限' })}${maxSubMoney || deductionScope}${getLabelText({
        key: getters?.ISGJTUS ? 'remote.common.dollar' : getters?.ISGJTEU ? 'remote.common.euro' : 'remote.common.yuan',
        text: getters?.ISGJTUS ? '美元' : getters?.ISGJTEU ? '欧元' : '元',
      })}`
    : ''
}
function getCouponUesRestrictive(i) {
  const getters = typeof window !== 'undefined' ? window?.app?.$store?.getters : false
  let array = [
    {
      text: i.orderMoneySill
        ? `${i.fullReductionType == fullDiscountType.circulation ? getLabelText({ key: 'remote.common.every', text: '每' }) : ''}${getLabelText({ key: 'remote.common.full', text: '满' })}${
            i.orderMoneySill
          }${getLabelText({
            key: getters?.ISGJTUS ? 'remote.common.dollar' : getters?.ISGJTEU ? 'remote.common.euro' : 'remote.common.yuan',
            text: getters?.ISGJTUS ? '美元' : getters?.ISGJTEU ? '欧元' : '元',
          })}${getLabelText({ key: 'remote.common.subtractive', text: '可减' })}`
        : getLabelText({ key: 'remote.common.noThreshold', text: '无门槛' }),
    },
    {
      text:
        i.userNumberRestrict == '1' || i.fullReductionType == fullDiscountType.circulation
          ? getLabelText({ key: 'remote.common.canBeSuperimposed', text: '可叠加' })
          : getLabelText({ key: 'remote.common.notStackable', text: '不可叠加' }),
    },
    { text: i.isFirstOrderUse == 1 ? getLabelText({ key: 'remote.common.limitedToTheFirstOrder', text: '限首单使用' }) : '' }
  ]
  return array.map((x) => x.text)
}
//最高可减
function getCouponMaxSubMoney(i) {
  return i.maxSubMoney || i.deductionScope ? `${getLabelText({ key: 'remote.common.theMaximumCanBeReduced', text: '最高可减' })}￥${i.maxSubMoney || i.deductionScope}` : ''
}

export {
  couponInvoicingType,
  showCommon,
  getDiscountTenths,
  getDiscountTenthsType,
  getCouponMoneyOrTenths,
  getDiscountTypeText,
  isCouponFullReduction,
  getCouponTypeText,
  getCouponSuffixText,
  getCouponBeforeText,
  getCouponMoneyShowText,
  getDeductionLimit,
  getCouponUesRestrictive,
  getCouponAllTypeText,
  getCouponMaxSubMoney,
  getCouponPriceIcon
}



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/common/coupon.js